export default class {
    constructor(options){
        if(options){
            this.client = options.client
            this.organizationID = options.organizationID
        }
    }
    // mark ***
    fetch(options){
        return this.client.get(`/availabilities`,{params: options})
    }
}


// WEBPACK FOOTER //
// ./lib/apiClient/organizations/availabilities.js